import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import { WebsiteImage } from 'components/TitleDescription';
import SubscribeForm from 'components/Form/SubscribeForm';
import useDefaultSubscribeForm from 'hooks/useDefaultSubscribeForm';
import MegaMenuItem from '../MegaMenuItem';
import { ResourceSubMenuContainer } from './styles';

const ResourceSubMenu = ({ isMenuOpened, setMobileMenuOpened, subNavElements = [] }) => {
  const mainNavElement = subNavElements[0];
  const inlineMarketingForm = useDefaultSubscribeForm();

  return (
    <ResourceSubMenuContainer
      className="mega-menu"
      isMenuOpened={isMenuOpened}
      isNoDescription={!subNavElements[1].description}
    >
      <div className="resource-sub-menu--container">
        <div className="resource-sub-menu--left-side">
          <div className="resource-sub-menu--main-menu-item">
            {mainNavElement && (
              <HyperLink data-position="Header - Menu Item CTA" href={mainNavElement.url}>
                <div className="mega-menu-item--content">
                  <WebsiteImage
                    className="mega-menu-item--icon"
                    src={mainNavElement.icon?.image}
                    alt={mainNavElement.icon?.alt}
                  />
                  <p className="mega-menu-item--title">{mainNavElement.label}</p>
                </div>
              </HyperLink>
            )}
          </div>
          <div className="resource-sub-menu--subscribe-container">
            <p className="resource-sub-menu--subscribe-description">
              A place for contractors to access the best content — articles, webinars, podcasts,
              industry-leading voices and expert advice, all in one place!
            </p>
            <div className="resource-sub-menu--subscribe-form">
              <SubscribeForm
                inlineMarketingForm={inlineMarketingForm}
                buttonType="secondary"
                notificationMessage="Thanks for subscribing!"
                shouldRedirect={false}
                formType="Email Capture"
                dataPosition="Navigation"
                label={null}
                shadow={false}
                notificationStyles={{ textAlign: 'left' }}
                notificationSnack={false}
              />
            </div>
          </div>
        </div>
        <div className="resource-sub-menu--right-side">
          <p className="resource-sub-menu--sub-title">EXPLORE THE TOOLBOX</p>
          <ul className="resource-sub-menu--menu-content">
            {subNavElements.map((item, index) => (
              <MegaMenuItem
                type="icon-title-desc"
                icon={
                  item.icon && item.icon.image && item.icon.image.file && item.icon.image.file.url
                }
                alt={item.icon && item.icon.alt}
                title={item.label}
                link={item.url}
                mobileShow={index === 0}
                key={index}
                setMobileMenuOpened={setMobileMenuOpened}
              >
                {item.description}
              </MegaMenuItem>
            ))}
          </ul>
        </div>
      </div>
    </ResourceSubMenuContainer>
  );
};

export default ResourceSubMenu;
